<template>
<div class="users">

    <div class="page-header">
        <h1><lang labelKey="PERMISSIONS-TITLE"></lang></h1>
    </div>

    <loading-indicator :loading="isLoading"></loading-indicator>

    <div class="columns" v-if="!isLoading">

		<div class="col-main">

			<v-client-table ref="tblPermissions" name="tblPermissions" class="tblPermissions noFirstColumn" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions">

                <!-- before table: FILTER OPTIONS -->
                <template slot="beforeTable">

                    <div class="columns is-marginless filters">

                        <!-- USER ROLE -->
                        <div class="column is-narrow">

                            <form-input
                                label="PERMISSIONS-FILTER-USERROLE"
                                maxWidth="250px"
                                inputType="select"
                                :selectIsSearchable="true"
                                :selectOptions="userRoles"
                                selectFieldName="name"
                                :showLabel="false"
                                :showLabelInOptions="false"
                                v-model="userRoleSelected"
                                :is-horizontal="false">

                            </form-input>

                        </div>

                        <!--search -->
                        <div class="column is-narrow">
                            <div class="control has-icon search" v-if="userRoleSelected != null">
                                <input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
                                <!-- <i class="fa icon-ak-suche"></i> -->
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </div>
                        </div>

                    </div>

                </template>


                <template slot="permission" slot-scope="props">

                    <!-- {{ props.row.temp }} -->

                    <form-input
                        label="PERMISSIONS-SELECT-PERMISSION"
                        maxWidth="250px"
                        inputType="select"
                        :selectIsSearchable="false"
                        :selectOptions="permissions"
                        :selectAllowEmpty="false"
                        :showLabel="false"
                        :showLabelInOptions="false"
                        selectCustomLabel="name"
                        v-model="props.row.temp"
                        @input="onChangePrivilege(props, $event)"
                        :is-horizontal="false">

                    </form-input>


                </template>

                <template slot="label" slot-scope="props">
                    <lang :labelKey="props.row.label"></lang>
                </template>

            </v-client-table>


		</div>

        <!--
		<div class="col-aside">

            <affix :offset="50">
                <div class="sidebox">
                    <custom-button type="blue" name="PERMISSIONS-BTN-SAVE" icon="icon-ak-speichern" @click.native="save"></custom-button>
                </div>
            </affix>

		</div>
        -->

    </div>


</div>
</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

    name: 'permissions',

    data() {

		return {

            apis: [],
            userRoles: [],
            userRoleSelected: null,
            searchString: null,

            permissions: [
                { name: this.$t('API_PERMISSION_NONE'), privileges: [] },
                { name: this.$t('API_PERMISSION_READ'), privileges: ['read'] },
                { name: this.$t('API_PERMISSION_READ_WRITE'), privileges: ['read', 'update'] },
                { name: this.$t('API_PERMISSION_FULL_CONTROL'), privileges: ['read', 'update', 'create', 'delete'] },
            ],

			isLoading: false,

            table: {

                tblData: [],
                tblColumns: ['label', 'permission'],
                tblOptions: {
                    destroyEventBus: true,
                    uniqueKey: 'label',
                    // saveState: true,
                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'label'
                    },
                    headings: {
                        label: function(h) {
    						return <lang labelKey="PERMISSIONS-TBL_HEADER-LABEL"></lang>
    					},
    					permission: function(h) {
    						return <lang labelKey="PERMISSIONS-TBL_HEADER-PERMISSION"></lang>
    					},
                    },

					sortable: ['label'],

                    filterByColumn: false,
					filterable: false,

					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'keine passenden Einträge gefunden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},

					pagination: {
						chunk: 5
					},

					// skin: 'table-striped table-bordered table-hover',
                    // skin: 'is-bordered is-striped is-hoverable is-fullwidth',
                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
					customFilters: [
						{
							name: 'search',
							callback(row, string) {

								if(string == null || string == "") {
									return true;
								}

								string = string.toLowerCase();

                                return row.name.toLowerCase().indexOf(string) > -1;

							}
						},
                    ],

                }
            },

		}
	},

    created() {

		this.fetchData();

	},


    mounted() {

	},

    updated() {

	},

    watch: {

        searchString(newVal, oldVal) {
            Event.$emit('vue-tables.tblPermissions.filter::search', newVal);
		},

        userRoleSelected(newVal, oldVal) {

            if(newVal == oldVal) {
                return;
            }

            var self = this;
            this.table.tblData = [];

            if(newVal == null) {
                return;
            }

            this.apis.forEach((api, index) => {

                var name = "";
                let found = newVal.permissions.find(function(perm) { return perm.api == api.name });
                api.temp = {};

                if(typeof found != 'undefined') {

                    if(found.privileges.indexOf('delete') > -1) {
                        name = 'API_PERMISSION_FULL_CONTROL';
                    }
                    else if(found.privileges.indexOf('update') > -1) {
                        name = "API_PERMISSION_READ_WRITE";
                    }
                    else if(found.privileges.indexOf('read') > -1) {
                        name = "API_PERMISSION_READ";
                    }
                    else if(found.privileges.length == 0) {
                        name = "API_PERMISSION_NONE";
                    }

                    api.temp = {
                        name: name,
                        customLabel: this.$t(name),
                        privileges: found.privileges
                    }

                } else {

                    api.temp = {
                        name: 'API_PERMISSION_NONE',
                        customLabel: this.$t('API_PERMISSION_NONE'),
                        privileges: []
                    }
                }

                self.table.tblData.push(api);

            })

        },

    },

    methods: {

        search() {

            var self = this;
            setTimeout(function() {
                Event.$emit('vue-tables.tblPermissions.filter::search', self.searchString)
            }, 200)

        },


        onChangePrivilege(props, selection) {

            let api = props.row.name;
            var self = this;

            if(selection != null) {

                let foundIndex = this.table.tblData.findIndex((row) => { return row.name == props.row.name} );
                this.table.tblData[foundIndex].temp = selection.privileges;


                var createNew = true;
                for(var key in this.userRoleSelected.permissions) {

                    if(self.userRoleSelected.permissions[key].api == api) {
                        createNew = false;
                        self.userRoleSelected.permissions[key].privileges = selection.privileges;
                    }

                }


                if(createNew) {

                    let permission = {
                        api: api,
                        privileges: selection.privileges,
                        readFields: [ ],
                        hideFields: [ ],
                        updateFields: [ ],
                        filters: null,
                        userRole: self.userRoleSelected.id
                    }

                    self.userRoleSelected.permissions.push(permission);

                }

                // save
                self.entityCreateOrUpdate('userRole', self.userRoleSelected)
                    .then((response) => {

                        if(createNew) {
                            self._fetchPermissionsByUserRole(self.userRoleSelected.id, api);
                        }

                    })
            }

        },

        _fetchPermissionsByUserRole(roleId, api) {

            var self = this;
            this.axios.get(this.$config.api + 'userRole?filters[isAdminRole]=0&orderBy=name%20ASC&include=userRole.permissions&filters[id]='+roleId)
                .then((response) => {

                    response.data.userRole[0].permissions.some((permission) => {

                        if(permission.api == api) {
                            self.userRoleSelected.permissions[self.userRoleSelected.permissions.length-1] = permission;
                            return;
                        }

                    })

                })

        },

        fetchData() {

			this.isLoading = true;
			var self = this;

			function getAPIs() {
				return self.axios.get(self.$config.api + 'discover/apis')
			}
      
      function getUserRoles() {
          return self.axios.get(self.$config.api + 'userRole?filters[isAdminRole]=0&orderBy=name%20ASC&include=userRole.permissions')
      }

			// make the request
			this.axios.all([getAPIs(), getUserRoles()])

				.then(self.axios.spread(function (apis, userRoles) {

                    for (var key in apis.data) {

                        if (!apis.data.hasOwnProperty(key)) continue;

                        // console.log(apis.data[key]);
                        self.apis.push({
                            name: key,
                            label: 'API-'+key.toUpperCase(),
                        })

                    }

                    // exclude user roles with isAdminRole == true
                    userRoles.data.userRole.forEach((userRole) => {
                        if(!userRole.isAdminRole) {
                            // console.log("userRole: ", userRole);
                            self.userRoles.push(userRole)
                        }
                    })

					self.isLoading = false;

				})).catch(function(error) {
					self.isLoading = false;
					console.log('Error: ', error.message);
				});


        }

    }

}


</script>


<style scoped>
    >>> .tblPermissions tr td {
        overflow: visible;
    }
</style>
